import React, { useCallback, useMemo, useState } from 'react'
import DatePicker from 'react-datepicker'
import { faChevronDown, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'

export const useDatepicker = () => {
  const [startDate, startDateSet] = useState<Date | null>(null)
  const [endDate, endDateSet] = useState<Date | null>(null)

  const formatting = useMemo((): string => {
    let dateDisplay = ''
    if (startDate) dateDisplay = startDate.toLocaleDateString()
    if (endDate)
      dateDisplay = dateDisplay + ' - ' + endDate.toLocaleDateString()
    return dateDisplay || 'All'
  }, [startDate, endDate])

  const handleClear = useCallback(() => {
    startDateSet(null)
    endDateSet(null)
  }, [startDateSet, endDateSet])

  const handlePick = useCallback(
    (dates: [Date | null, Date | null] | null): void => {
      if (dates) {
        startDateSet(dates[0])
        endDateSet(dates[1])
      }
    },
    [startDateSet, endDateSet]
  )

  const DatepickerInput = ({
    title,
    value,
    onClick,
    onClear,
    showClearIcon,
  }: {
    title?: string
    value?: string
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    onClear?: () => void
    showClearIcon?: boolean
  }) => (
    <div className="flex flex-col gap-2">
      {title && (
        <label>
          <span className="tracking-wider font-light">{title}</span>
        </label>
      )}
      <div className="relative">
        <button
          className="p-2 pr-16 text-left border border-gray-400 relative flex items-center w-full"
          style={{ minWidth: '120px' }}
          onClick={onClick}
          type="button"
        >
          <span className="tracking-wider">{value || 'All'}</span>
        </button>
        <div className="absolute right-0 top-0 h-full flex items-center pr-2">
          {showClearIcon && (
            <Icon
              icon={faTimes}
              className="ml-2 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation()
                onClear?.()
              }}
            />
          )}
          <Icon
            icon={faChevronDown}
            className="ml-2"
          />
        </div>
      </div>
    </div>
  )

  return {
    startDate,
    endDate,
    handlePick,
    handleClear,
    DatepickerInput,
  }
}
